import { createSelector } from 'reselect';
import { getPropKey, getStateKey } from './commonSelectors';

export const getHasTimeDropdown = getPropKey('hasTimeDropdown');
export const getIs24Hour = getPropKey('is24Hour');
export const getHasAnytime = getPropKey('hasAnytime');
export const getMinutesIntervalPerOption = getPropKey('minutesIntervalPerOption');
export const getDefaultTime = getPropKey('defaultTime');
export const getNewLabelEnabled = getPropKey('isEnabledNewTimeLabel');

export const getStartTime = getStateKey('startTime');
export const getEndTime = getStateKey('endTime');

export const getIsAbleToResetTimes = createSelector(
  getStartTime,
  getEndTime,
  getHasTimeDropdown,
  (startTime, endTime, hasTimeDropdown) => (hasTimeDropdown ? startTime || endTime : false)
);
